export const MenuItemIconSize = 'w-6 h-6 md:w-5 md:h-5';
